import { useThemeContext } from '@huggg/react-components';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styles from './prepaidCard.module.scss';

// The legacy React lint rule does not recognise error events on SVG images.
/* eslint-disable react/no-unknown-property */

const CardImage = ({ cardData, cardTitle, design, isHeatingCard }) => {
  const { operator } = useThemeContext();
  // A card still being created has null digits, and a destructuring default
  // only covers undefined, so mask explicitly: all sixteen read as X.
  const { expiryDate } = cardData || {};
  const last4Digits = cardData?.last4Digits ?? 'XXXX';
  const nameOnCard = cardData?.nameOnCard ?? 'XXXX';

  const topCardFill = isHeatingCard ? '#EA5F40' : '#546CD3';
  const bottomCardFill = isHeatingCard ? '#F7B51D' : '#4DC44D';
  const backgroundUrl = design?.backgroundUrl;
  const [failedBackgroundUrl, setFailedBackgroundUrl] = useState(null);
  const hasCustomArtwork =
    Boolean(backgroundUrl) && failedBackgroundUrl !== backgroundUrl;

  const cardDisplayName = nameOnCard.slice(0, 23);
  const formattedExpiryDate = expiryDate
    ? expiryDate.replace(/\d\d(\d{2})-(\d{2}).*/, '$2 / $1')
    : 'XX / XX';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 1011 638"
      alt="Prepaid Card"
      className={styles.cardImage}
    >
      <g clipPath="url(#a)">
        {hasCustomArtwork ? (
          <image
            href={backgroundUrl}
            xlinkHref={backgroundUrl}
            width="1011"
            height="638"
            preserveAspectRatio="xMidYMid slice"
            onError={() => setFailedBackgroundUrl(backgroundUrl)}
          />
        ) : (
          <g>
            <path fill="#fff" d="M-94-27h1200v692.22H-94z" />
            <path fill={topCardFill} d="M-94-27h1200v692H-94z" />
            <path
              fill={bottomCardFill}
              d="M416.316 413.33c191.733 61.998 442.93-107.275 564.441 73.574C1120.59 695.015 1136.22 1056.2 968.796 1235.6c-160.991 172.51-405.729-74.29-626.031-65.06-193.07 8.09-416.212 282.13-541.836 113.99-127.046-170.04 130.055-388.181 174.04-606.248 34.725-172.165-87.402-418.665 49.229-500.688C161.756 95.014 266.853 365 416.316 413.33Z"
            />
            {operator.showHugggPromotions && (
              <path
                fill="#fff"
                d="M780.929 85.914h5.095c.653 0 1.171.639 1.14 1.405l-.582 15.79c-.031.797.881 1.068 1.184.352 1.442-3.422 4.194-7.7 8.912-7.7 5.629 0 8.184 3.535 8.184 16.007v10.266c0 .743-.511 1.351-1.14 1.351h-4.587c-.629 0-1.141-.604-1.141-1.351v-7.037c0-7.549-1.478-10.011-5.071-10.011s-6.27 5.137-6.27 12.527v4.521c0 .743-.511 1.351-1.14 1.351h-4.588c-.629 0-1.14-.604-1.14-1.351V87.261c0-.743.511-1.347 1.14-1.347M832.082 123.381h-5.044c-.668 0-1.191-.677-1.136-1.463l.322-4.467c.059-.798-.849-1.119-1.167-.411-1.483 3.326-4.191 7.196-8.763 7.196-5.59 0-8.146-3.534-8.146-16.006V97.96c0-.743.511-1.347 1.14-1.347h4.588c.629 0 1.14.604 1.14 1.347v8.807c0 5.524 1.439 8.469 5.032 8.469s6.306-3.596 6.306-11.171v-6.29c0-.562.511-1.166 1.14-1.166h4.588c.629 0 1.14.604 1.14 1.348v24.073c0 .743-.511 1.347-1.14 1.347M839.101 131.061v-5.926c0-.751.676-1.227 1.238-.875 1.954 1.219 5.06 2.551 8.346 2.551 5.111 0 7.422-2.571 7.67-7.254 0-.016.008-.031.012-.043.141-.79-.743-1.212-1.133-.55-1.792 3.062-4.894 4.638-8.467 4.638-6.306 0-10.619-5.141-10.619-13.816s4.352-14.024 10.261-14.024c4.839 0 7.622 3.375 9.081 6.108.346.643 1.191.31 1.144-.449l-.201-3.36c-.043-.778.476-1.444 1.14-1.444h4.423c.629 0 1.14.604 1.14 1.351v22.208c0 9.689-5.433 13.916-13.295 13.916-3.896 0-6.978-.612-9.832-1.599-.539-.185-.908-.766-.908-1.432m16.409-21.166c0-4.603-3.114-6.852-6.428-6.852s-6.306 2.249-6.306 6.852c0 4.602 2.913 7.064 6.306 7.064 3.393 0 6.428-2.408 6.428-7.064ZM868.636 131.061v-5.926c0-.751.676-1.227 1.238-.875 1.954 1.219 5.06 2.551 8.346 2.551 5.111 0 7.422-2.571 7.67-7.254 0-.016.008-.031.012-.043.141-.79-.743-1.212-1.132-.55-1.793 3.062-4.895 4.638-8.468 4.638-6.306 0-10.618-5.141-10.618-13.816s4.351-14.024 10.26-14.024c4.839 0 7.623 3.375 9.081 6.108.346.643 1.191.31 1.144-.449l-.2-3.36c-.048-.778.475-1.444 1.14-1.444h4.422c.629 0 1.14.604 1.14 1.351v22.208c0 9.689-5.433 13.916-13.295 13.916-3.896 0-6.978-.612-9.832-1.599-.539-.185-.908-.766-.908-1.432m16.409-21.166c0-4.603-3.114-6.852-6.428-6.852s-6.305 2.249-6.305 6.852c0 4.602 2.913 7.064 6.305 7.064 3.393 0 6.428-2.408 6.428-7.064ZM898.175 131.061v-5.926c0-.751.676-1.227 1.238-.875 1.954 1.219 5.06 2.551 8.346 2.551 5.111 0 7.422-2.571 7.67-7.254 0-.016.008-.031.012-.043.141-.79-.743-1.212-1.132-.55-1.793 3.062-4.895 4.638-8.468 4.638-6.306 0-10.618-5.141-10.618-13.816s4.352-14.024 10.26-14.024c4.839 0 7.623 3.375 9.081 6.108.346.643 1.191.31 1.144-.449l-.2-3.36c-.048-.778.475-1.444 1.14-1.444h4.422c.629 0 1.14.604 1.14 1.351v22.208c0 9.689-5.433 13.916-13.295 13.916-3.896 0-6.978-.612-9.832-1.599-.538-.185-.908-.766-.908-1.432m16.409-21.166c0-4.603-3.114-6.852-6.428-6.852s-6.305 2.249-6.305 6.852c0 4.602 2.913 7.064 6.305 7.064 3.393 0 6.428-2.408 6.428-7.064Z"
              />
            )}
            <path fill="#FF5F00" d="M874.34 471.172h-42v75.475h42v-75.475Z" />
            <path
              fill="#EB001B"
              d="M835.005 508.91a47.929 47.929 0 0 1 18.333-37.737 47.998 47.998 0 0 0-77.662 37.737 48 48 0 0 0 77.662 37.738 47.918 47.918 0 0 1-18.333-37.738Z"
            />
            <path
              fill="#F79E1B"
              d="M931 508.91a48.002 48.002 0 0 1-27.02 43.173 48.002 48.002 0 0 1-50.64-5.435 48.016 48.016 0 0 0 18.333-37.738 48 48 0 0 0-18.333-37.737A47.998 47.998 0 0 1 931 508.91ZM926.421 538.652v-1.545h.623v-.315h-1.587v.315h.623v1.545h.341Zm3.08 0v-1.863h-.486l-.559 1.282-.56-1.282h-.487v1.863h.344v-1.405l.524 1.211h.357l.524-1.214v1.408h.343Z"
            />
            <text
              x="80.292"
              y="120"
              fill="#FFF"
              className={styles.cardImageCardTitle}
            >
              {cardTitle}
            </text>
          </g>
        )}
        <text
          x="80.292"
          y="319"
          fill="#FFF"
          className={styles.cardImageCardNumber}
        >
          XXXX XXXX XXXX {last4Digits}
        </text>
        {!hasCustomArtwork && (
          <g>
            <text
              x="80.292"
              y="500"
              fill="#FFF"
              className={styles.cardImageDetailLabel}
            >
              {dictionary.prepaidCards.labels.cardImageCardholderName}
            </text>
            <text
              x="80.292"
              y="550"
              fill="#FFF"
              className={styles.cardImageNameExpiry}
            >
              {cardDisplayName}
            </text>
            <text
              x="598"
              y="500"
              fill="#FFF"
              className={styles.cardImageDetailLabel}
            >
              {dictionary.prepaidCards.labels.cardImageExpiryDate}
            </text>
            <text
              x="600"
              y="550"
              fill="#FFF"
              className={styles.cardImageNameExpiry}
            >
              {formattedExpiryDate}
            </text>
          </g>
        )}
      </g>
      <defs>
        <clipPath id="a">
          <rect width={1011} height={637.5} fill="#fff" rx={44} />
        </clipPath>
      </defs>
    </svg>
  );
};

CardImage.propTypes = {
  cardData: PropTypes.object,
  cardTitle: PropTypes.string.isRequired,
  design: PropTypes.shape({
    backgroundUrl: PropTypes.string.isRequired,
  }),
  isHeatingCard: PropTypes.bool,
};

export default CardImage;
